import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: null,
  error: null,
  loading: false,
  emailVarified: false,
  resendCode: false,
  verifyPassword: {
    data: null,
    error: null,
    loading: false,
  },
  createPassword: {
    data: null,
    error: null,
    loading: false,
  }
};

const signUpSlice = createSlice({
  name: 'signUp',
  initialState,
  reducers: {
    signUpUserStart: state => {
      state.data = null;
      state.loading = true;
      state.error = null;
    },
    signUpUserSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
    },
    signUpUserFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = null;
    },
    resetFromState: (state, action) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
    resetFromState: (state, action) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
    emailVerificationStart: (state, action) => {
      state.resendCode = false;
      state.loading = true;
      state.error = null;
      state.emailVarified = false;
    },
    emailVerificationFailure: (state, action) => {
      state.resendCode = false;
      state.loading = false;
      state.error = action.payload;
      state.emailVarified = false;
    },
    emailVerificationSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.data = action.payload,
      state.emailVarified = true;
      state.resendCode = false;
    },
    resendEmailVerificationStart: (state, action) => {
      state.resendCode = false;
      state.loading = false;
      state.error = null;
    },
    resendEmailVerificationFailure: (state, action) => {
      state.resendCode = false;
      state.loading = false;
      state.error = action.payload;
    },
    resendEmailVerificationSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.resendCode = true;
    },
    resetResendFormState: (state, action) => {
      state.error = null;
      state.resendCode = false;
    },
    verifyPasswordStart: state => {
      state.verifyPassword.data = null;
      state.verifyPassword.loading = true;
      state.verifyPassword.error = null;
    },
    verifyPasswordSuccess: (state, action) => {
      state.verifyPassword.loading = false;
      state.verifyPassword.data = action.payload;
      state.verifyPassword.error = null;
    },
    verifyPasswordFailure: (state, action) => {
      state.verifyPassword.loading = false;
      state.verifyPassword.error = action.payload;
      state.verifyPassword.data = null;
    },
    createPasswordStart: state => {
      state.createPassword.data = null;
      state.createPassword.loading = true;
      state.createPassword.error = null;
    },
    createPasswordSuccess: (state, action) => {
      state.createPassword.loading = false;
      state.createPassword.data = action.payload;
      state.createPassword.error = null;
    },
    createPasswordFailure: (state, action) => {
      state.createPassword.loading = false;
      state.createPassword.error = action.payload;
      state.createPassword.data = null;
    },
    resetAllFormState: (state, action) => {
      state.data = null,
      state.error = null,
      state.loading = false,
      state.emailVarified = false,
      state.resendCode = false,
      state.verifyPassword = {
        data: null,
        error: null,
        loading: false,
      },
      state.createPassword = {
        data: null,
        error: null,
        loading: false,
      }
    },
  },
});

export const { 
  signUpUserStart, 
  signUpUserSuccess, 
  signUpUserFailure, 
  resetFromState,
  emailVerificationStart,
  emailVerificationFailure,
  emailVerificationSuccess,
  resendEmailVerificationStart,
  resendEmailVerificationFailure,
  resendEmailVerificationSuccess,
  resetResendFormState,
  verifyPasswordSuccess,
  verifyPasswordStart,
  verifyPasswordFailure,
  createPasswordFailure,
  createPasswordSuccess,
  createPasswordStart,
  resetAllFormState
} = signUpSlice.actions;

export default signUpSlice.reducer;
